import React, { useEffect, useState } from "react";
import styles from "./AlumniCard.module.scss";
import InfoButton from "../../Atoms/InfoButton/InfoButton";
import moreInfo from "../../../assets/icons/programs/major/moreInfo.svg";
import editSvg from "../../../assets/icons/formActions/edit.svg";
import deleteSvg from "../../../assets/icons/formActions/delete.svg";
import { useNavigate, useParams } from "react-router-dom";
import DeletePopup from "../Custom/DeletePopup";
import noImageFound from "../../../assets/Imagess/no-image-found.jpg";
import he from "he";
import { useDeleteAmbassador, useDeleteStory } from "../../../Hooks/Alumni";
import AlumniInfo from "../Alumni/AlumniInfo";
import { useToast } from "../Custom/CustomToaster/Toast";
import { sanitizeAndValidateUrl } from "../../../app/helpers/sanitizeAndValidateUrl";

function AlumniCard({ data, refetch, selected, type }) {
  const [showInfo, setShowInfo] = useState(false);
  const navigate = useNavigate();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const customizedToast = useToast();
  const {
    mutate: deleteAmbassador,
    isLoading: isDeletingAmbassador,
    isSuccess: isSuccessDeleteAmbassador,
  } = useDeleteAmbassador(data?.alumniAmbassadorId);

  const {
    mutate: deleteStory,
    isLoading: isDeletingStory,
    isSuccess: isSuccessDeleteStory,
  } = useDeleteStory(data?.alumniSuccessStoryId);

  const menuItems = [
    {
      label: 'تعديل',
      icon: editSvg,
      onClick: () => {
        'ambassador' === type
          ? navigate(`/home/edit-ambassador/${data?.alumniAmbassadorId}`)
          : navigate(`/home/edit-success-story/${data?.alumniSuccessStoryId}`);
      },
    },
    {
      label: 'حذف',
      icon: deleteSvg,
      onClick: () => {
        setShowDeletePopup(true);
      },
    },
  ];

  useEffect(() => {
    if (isSuccessDeleteAmbassador || isSuccessDeleteStory) {
      setShowDeletePopup(false);
      customizedToast.open('تم الحذف بنجاح');
      refetch();
    }
  }, [isSuccessDeleteAmbassador, isSuccessDeleteStory]);

  return (
    <div className={styles['news-card']}>
      {'ambassador' === type ? (
        <img
          src={sanitizeAndValidateUrl(`${data?.url}${data?.ambassadorImage}`)}
          className={styles['news-card-image']}
          onClick={() => setShowInfo(true)}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = noImageFound;
          }}
        />
      ) : (
        <img
          src={sanitizeAndValidateUrl(`${data?.url}${data?.alumniImage}`)}
          className={styles['news-card-image']}
          onClick={() => setShowInfo(true)}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = noImageFound;
          }}
        />
      )}
      <div className={styles['news-card-info']}>
        <div className={styles['row']}>
          <InfoButton
            icon={moreInfo}
            className={styles['more-info']}
            data={menuItems}
            left
          />{' '}
          <div>
            {'ambassador' === type ? (
              <>
                <p className={styles['key']}>الاسم</p>
                <p className={styles['value']}>{data?.ambassadorName_AR}</p>
                <p className={styles['key']}>Country</p>
                <p className={styles['value']}>
                  {data?.flag && data?.flag[0]?.countryName_AR}
                </p>
              </>
            ) : (
              <>
                <p className={styles['key']}>الاسم</p>
                <p className={styles['value']}>{data?.alumniName_AR}</p>
                <p className={styles['key']}>إنجازات الخريجين</p>
                <div className={styles['description']}>
                  <p
                    className={styles['title']}
                    dangerouslySetInnerHTML={{
                      __html: he.decode(data.achievements_AR),
                    }}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {showDeletePopup && (
        <DeletePopup
          handleOnClose={() => setShowDeletePopup(false)}
          title={type === 'ambassador' ? 'السفير' : 'القصة'}
          handleDelete={() => {
            'ambassador' === type ? deleteAmbassador() : deleteStory();
          }}
          isLoading={isDeletingAmbassador}
        />
      )}
      {showInfo && (
        <AlumniInfo
          data={data}
          handleOnClose={() => setShowInfo(false)}
          setShowDeletePopup={setShowDeletePopup}
          type={type}
        />
      )}
    </div>
  );
}

export default AlumniCard;
